import AppHeaderAuthenticated from '~/components/Layout/AppHeaderAuthenticated.vue'
import AppFooter from '~/components/Layout/AppFooter.vue'

const __default__ = {
    middleware: 'auth',
    name: 'AuthenticatedLayout',
}

export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {


return { __sfc: true,AppHeaderAuthenticated, AppFooter }
}

})